import { ActiveModelSerializer } from 'active-model-adapter';
import DS, { ModelSchema } from 'ember-data';
import { isNone } from '@ember/utils';
import { IdentifierKey } from 'cio/utils/identifiers';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

// Temporary: this will rename cid to cio_id while the back end is still
// being worked on for multi-id work. It should become dead code once the
// back end for multi-id goes out and can then be safely removed later.
export default ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    users: {
      serialize: 'ids',
    },
  },

  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    if (!isNone(hash?.identifiers?.cid) && isNone(hash?.identifiers[IdentifierKey.CioId])) {
      hash.identifiers[IdentifierKey.CioId] = hash.identifiers.cid;
      delete hash.identifiers.cid;
    }

    return this._super(modelClass, hash, prop);
  },
});
